import type { OatfiBusiness, PlaidLink } from 'src/interfaces/oatfiBusiness'
import type { State } from '../reducers/types'

/**
 * Every selector here returns a stored value by reference. Never build an object or array
 * literal in a selector — each consuming `useSelector` would re-render on every dispatch.
 *
 * The setup status strip is deliberately not a selector: `deriveSetupStatus` in
 * `utils/oatfiBusiness.ts` builds a fresh array, so as a selector it would re-render every
 * consumer on every dispatch. It is a pure function called from the page instead, which also
 * keeps it testable without a store.
 */
export const getOatfiBusiness = (state: State): OatfiBusiness | null => {
  return state.oatfiBusiness.business
}

export const getOatfiBusinessPartnerId = (state: State): string | null => {
  return state.oatfiBusiness.partnerId
}

export const getOatfiBusinessLoading = (state: State): boolean => {
  return state.oatfiBusiness.loading
}

export const getOatfiBusinessLoaded = (state: State): boolean => {
  return state.oatfiBusiness.loaded
}

export const getOatfiBusinessError = (state: State): string | null => {
  return state.oatfiBusiness.error
}

export const getOatfiBusinessSaving = (state: State): boolean => {
  return state.oatfiBusiness.saving
}

export const getOatfiUnderwritingRequesting = (state: State): boolean => {
  return state.oatfiBusiness.requestingUnderwriting
}

export const getOatfiSupplementalUploading = (state: State): boolean => {
  return state.oatfiBusiness.uploadingSupplemental
}

export const getHistoricalInvoicesUploading = (state: State): boolean => {
  return state.oatfiBusiness.uploadingHistorical
}

export const getOatfiPaymentMethodCreating = (state: State): boolean => {
  return state.oatfiBusiness.creatingPaymentMethod
}

export const getPlaidLink = (state: State): PlaidLink | null => {
  return state.oatfiBusiness.plaidLink
}

export const getPlaidLinkGenerating = (state: State): boolean => {
  return state.oatfiBusiness.generatingPlaidLink
}
